import { endOfDay } from "date-fns";
import { AlertTriangle, type LucideIcon } from "lucide-react";
import { ROLES } from "@user-management-context/shared/domain/types/enums/roles";

export type NoticeTone = "info" | "warning";

export interface NoticeLink {
  label: string;
  href: string;
}

export interface Notice {
  id: string;
  title: string;
  paragraphs: string[];
  link?: NoticeLink;
  icon: LucideIcon;
  tone: NoticeTone;
  roles: ROLES[];
  /** Dernier instant d'affichage, en dur → la bannière disparaît d'elle-même, personne à qui rappeler de la retirer. */
  until: Date;
}

// Annonces temporaires affichées en haut de l'app. Pour en ajouter une : une entrée ici, rien d'autre.
export const NOTICES: Notice[] = [
  {
    id: "afdas-is-2027-reopening",
    title: "AFDAS – Intermittents",
    paragraphs: [
      "L'AFDAS ne prend plus en charge les formations débutant avant le 18 janvier 2027.",
      "Vous pouvez déposer votre demande dès maintenant dans « Nouveau financement » pour une formation débutant à partir de cette date. Nous la transmettrons à l'AFDAS, qui publiera ses règles 2027 courant décembre.",
    ],
    link: {
      label: "Les conditions sur le site de l'AFDAS",
      href: "https://www.afdas.com/particulier/connaitre-les-dispositifs-et-les-modalites-dacces-a-la-formation/intermittents-du-spectacle-et-de-laudiovisuel/quelles-conditions.html",
    },
    icon: AlertTriangle,
    tone: "warning",
    roles: [ROLES.STUDENT],
    // 17 janvier 2027, 23:59:59.999 (heure locale) : le 18 une formation peut débuter, le message est caduc.
    until: endOfDay(new Date(2027, 0, 17)),
  },
];
